import TopPostsSection from './TopPostsSection';
import { getCategoryTopPosts } from 'utils/api/instagram.api';

const CategoryTopPostsSection = ({
    year,
    week,
    categories,
    countries,
    name,
    displayQty,
    perPage,
    ...rest
}) => {
    const queryParams = {
        category: categories || null,
        country: countries || null,
    };

    return (
        <TopPostsSection
            year={year}
            week={week}
            name={name}
            queryFn={getCategoryTopPosts}
            queryParams={queryParams}
            displayQty={displayQty}
            perPage={perPage}
            {...rest}
        />
    );
};

export default CategoryTopPostsSection;
